import React from 'react';
import { Helmet } from 'react-helmet';
import { motion } from 'framer-motion';
import { FaWhatsapp, FaMapMarkerAlt, FaCalendarAlt, FaUsers, FaStar, FaCheck, FaTimes, FaBus, FaClock } from 'react-icons/fa';
import BookingForm from '../../components/common/BookingForm';
import { companyInfo } from '../../data/tourData';
import './ManimaheshTour.css';

const ManimaheshTour = () => {
  return (
    <>
      <Helmet>
        <title>Manimahesh Tour - NomadTrailz</title>
        <meta name="description" content="Experience the sacred Manimahesh pilgrimage with NomadTrailz. Trek to Manimahesh Lake and witness the divine Mani Darshan." />
      </Helmet>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        {/* Hero Section */}
        <section className="destination-hero">
          <div className="hero-background">
            <img 
              src="https://res.cloudinary.com/duym2bgp2/image/upload/v1755709564/ke6skqxuoictodecfdpn.jpg" 
              alt="Manimahesh" 
            />
            <div className="hero-overlay"></div>
          </div>
          <div className="hero-content">
            <motion.h1 
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              Manimahesh Tour
            </motion.h1>
            <motion.p 
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              Sacred pilgrimage to Manimahesh Lake and divine Mani Darshan at 4,080 meters
            </motion.p>
          </div>
        </section>

        {/* Tour Details */}
        <section className="tour-details">
          <div className="container">
            <div className="details-grid">
              <div className="tour-info">
                <motion.div 
                  className="info-card"
                  initial={{ opacity: 0, x: -30 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.6 }}
                >
                  <h2>Tour Overview</h2>
                  <p>
                    Manimahesh is one of the most sacred pilgrimage sites in the Himalayas, located in the Chamba district 
                    of Himachal Pradesh. This spiritual journey takes you through the pristine landscapes of Himachal Pradesh to reach 
                    the divine Manimahesh Lake at 4,080 meters. Experience the spiritual ambiance and breathtaking 
                    natural beauty with comfortable accommodations and expert guidance through the challenging terrain.
                  </p>
                </motion.div>

                <motion.div 
                  className="highlights-card"
                  initial={{ opacity: 0, x: -30 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.6, delay: 0.2 }}
                >
                  <h3>Highlights</h3>
                  <ul>
                    <li>Sacred Manimahesh Lake at 4,080 meters</li>
                    <li>Divine Mani Darshan (Blink at Kailash)</li>
                    <li>Holy dip in Shiv Kund</li>
                    <li>Bharmani Mata Temple and 84 Temple visit</li>
                    <li>Bharmour Market exploration</li>
                    <li>Scenic trek through Hadsar</li>
                    <li>Challenging high altitude trekking</li>
                    <li>Cultural immersion in local villages</li>
                  </ul>
                </motion.div>

                <motion.div 
                  className="itinerary-card"
                  initial={{ opacity: 0, x: -30 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.6, delay: 0.4 }}
                >
                  <h3>Itinerary</h3>
                  <div className="day-item">
                    <h4>Day 0: Pick Up | Overnight Journey</h4>
                    <ul>
                      <li>Pick up from Chandigarh in evening</li>
                      <li>The group will assemble at the pickup point</li>
                      <li>Afterward, you'll get a small briefing from the trip leader</li>
                      <li>Halt for Dinner in between Journey (not on us)</li>
                    </ul>
                  </div>
                  <div className="day-item">
                    <h4>Day 1: Bharmour Arrival | Local Sightseeing</h4>
                    <ul>
                      <li>Reach Bharmour in morning around 8-9 AM</li>
                      <li>Check-in at stay. Relax for some time as you must be tired after a long Journey</li>
                      <li>By noon leave for Bharmani Mata Temple & 84 Temple</li>
                      <li>Explore Bharmour Market and try some local food</li>
                      <li>Return to stay Have Dinner & over night stay</li>
                    </ul>
                  </div>
                  <div className="day-item">
                    <h4>Day 2: Trek to Manimahesh Lake | Overnight Stay</h4>
                    <ul>
                      <li>Wake up early and enjoy the beautiful sunrise</li>
                      <li>Have your Breakfast and leave for Hadsar (Trek starting point)</li>
                      <li>Start your trek from Hadsar to Manimahesh lake (14 km)</li>
                      <li>Halt for Lunch in between trek</li>
                      <li>Reach Manimahesh Lake by 6-7 hours, check-in at camps near Shiv Kund and relax</li>
                      <li>Have evening snacks after that Briefing for next day trek</li>
                      <li>Have Dinner & Over night stay</li>
                    </ul>
                  </div>
                  <div className="day-item">
                    <h4>Day 3: Mani Darshan | Trek Down | Overnight Stay</h4>
                    <ul>
                      <li>Wake up early for Mani Darshan Blink at Kailash</li>
                      <li>Take Bath in Holy Shiv Kund</li>
                      <li>Have breakfast & start trek down to Hadsar</li>
                      <li>Halt for Lunch in between trek</li>
                      <li>Reach Bharmour Accommodation and rest for some time then head to 84 temple market for shoping</li>
                      <li>Return to accommodation Have dinner & overnight stay</li>
                    </ul>
                  </div>
                  <div className="day-item">
                    <h4>Day 4: Departure | Reach Chandigarh</h4>
                    <ul>
                      <li>Wake up and have breakfast</li>
                      <li>Check-out & Departure for Chandigarh</li>
                      <li>Halt for Lunch in between Journey</li>
                      <li>Reach Chandigarh After 9-10 Hours Journey</li>
                    </ul>
                  </div>
                </motion.div>

                <motion.div 
                  className="inclusions-card"
                  initial={{ opacity: 0, x: -30 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.6, delay: 0.6 }}
                >
                  <h3>Inclusions</h3>
                  <ul>
                    <li><FaCheck className="check-icon" />Accommodation (Basic Homestay & Camps)</li>
                    <li><FaCheck className="check-icon" />Meals (3 Breakfast, 3 lunch and 3 Dinner)</li>
                    <li><FaCheck className="check-icon" />Trek Guide, Driver, Road tax, Vehicle Parking</li>
                    <li><FaCheck className="check-icon" />Transportation in Tempo traveller</li>
                    <li><FaCheck className="check-icon" />Equipment's for climbing (if required)</li>
                  </ul>
                </motion.div>

                <motion.div 
                  className="exclusions-card"
                  initial={{ opacity: 0, x: -30 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.6, delay: 0.8 }}
                >
                  <h3>Exclusions</h3>
                  <ul>
                    <li><FaTimes className="times-icon" />Any personal Expenses / Adventure activities</li>
                    <li><FaTimes className="times-icon" />Anything not mentioned in the itinerary</li>
                    <li><FaTimes className="times-icon" />Any kind of entry tickets/fees</li>
                    <li><FaTimes className="times-icon" />Any Meals / Drinks other than Inclusion</li>
                    <li><FaTimes className="times-icon" />5%GST</li>
                    <li><FaTimes className="times-icon" />Personal Porter</li>
                  </ul>
                </motion.div>
              </div>

              <div className="booking-section">
                <motion.div 
                  className="booking-card"
                  initial={{ opacity: 0, x: 30 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.6 }}
                >
                  <h3>Book This Tour</h3>
                  <div className="price-info">
                    <span className="price">₹ 11,499</span>
                    <span className="duration">5 Days / 4 Nights</span>
                  </div>
                  
                  <div className="tour-features">
                    <div className="feature">
                      <FaMapMarkerAlt />
                      <span>Manimahesh, Himachal Pradesh</span>
                    </div>
                    <div className="feature">
                      <FaCalendarAlt />
                      <span>Best Time: May to October</span>
                    </div>
                    <div className="feature">
                      <FaUsers />
                      <span>Group Size: 8-12 people</span>
                    </div>
                    <div className="feature">
                      <FaStar />
                      <span>Difficulty: Challenging</span>
                    </div>
                  </div>

                  <div className="pricing-options">
                    <h4>Cost Per Person</h4>
                    <div className="price-option">
                      <span className="option">TRIPLE SHARE</span>
                      <span className="amount">₹ 11,499 + 5% GST</span>
                    </div>
                    <div className="price-option">
                      <span className="option">DOUBLE SHARE</span>
                      <span className="amount">₹ 11,999 + 5% GST</span>
                    </div>
                  </div>
                </motion.div>

                <motion.div 
                  className="tour-logistics-card"
                  initial={{ opacity: 0, x: 30 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.6, delay: 0.1 }}
                >
                  <h3>Tour Logistics</h3>
                  <div className="logistics-grid">
                    <div className="logistics-item">
                      <FaBus className="logistics-icon" />
                      <div className="logistics-content">
                        <span className="logistics-label">Pickup Point:</span>
                        <span className="logistics-value">Chandigarh Bus Stand</span>
                      </div>
                    </div>
                    <div className="logistics-item">
                      <FaClock className="logistics-icon" />
                      <div className="logistics-content">
                        <span className="logistics-label">Pickup Time:</span>
                        <span className="logistics-value">10 PM</span>
                      </div>
                    </div>
                    <div className="logistics-item">
                      <FaMapMarkerAlt className="logistics-icon" />
                      <div className="logistics-content">
                        <span className="logistics-label">Maximum Altitude:</span>
                        <span className="logistics-value">4,080 metres</span>
                      </div>
                    </div>
                    <div className="logistics-item">
                      <FaStar className="logistics-icon" />
                      <div className="logistics-content">
                        <span className="logistics-label">Trek Distance:</span>
                        <span className="logistics-value">Approx. 14 km</span>
                      </div>
                    </div>
                  </div>
                </motion.div>
              </div>

              <motion.div
                initial={{ opacity: 0, x: 30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
              >
                <BookingForm 
                  tourName="Manimahesh Sacred Pilgrimage"
                  tourPrice="₹ 11,499"
                  tourDuration="5 Days / 4 Nights"
                />
              </motion.div>
            </div>
          </div>
        </section>
      </motion.div>
    </>
  );
};

export default ManimaheshTour;

